@if (loading) {
  <section class="loading">
    <mat-icon>autorenew</mat-icon>
    Loading images&hellip;
  </section>
}
@if (!loading) {
  @for (image of CarouselImages; track image) {
    @if (image.featured) {
      <img
        [src]="getImageUrl(image)"
        [title]="image.title"
        alt="Featured Image"
        class="featured"
        />
    }
  }
  <section class="images">
    @if (editable) {
      <label class="mat-button"
        >Images
        <button
          (click)="edit()"
          mat-button
          matTooltip="Edit images."
          type="button"
          >
          <mat-icon>photo_library</mat-icon>
          Edit
        </button>
      </label>
    }
    @for (image of CarouselImages; track image) {
      <img
        [src]="getImageUrl(image)"
        [title]="image.title"
        alt="{{image.title}}"
        />
    }
  </section>
}
